import { render, staticRenderFns } from "./index.vue?vue&type=template&id=62e74b7e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=62e74b7e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e74b7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62e74b7e')) {
      api.createRecord('62e74b7e', component.options)
    } else {
      api.reload('62e74b7e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=62e74b7e&scoped=true", function () {
      api.rerender('62e74b7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/statistics/statistics-progress/index.vue"
export default component.exports